import { post, downloadFile } from 'utils/api';
import { CS_CHARGER_STATUS, CHARGING_STATIONS, WIDGETS } from './endpointURLs';

export const getChargerStatus = (data) => {
  let queryParams = [];
  if (data.sortBy) {
    queryParams.push(`sortBy=${data.sortBy}`);
  }
  if (data.search) {
    queryParams.push(`search=${data.search}`);
  }
  queryParams.push(`page=1`);
  queryParams.push(`limit=10000`);

  const cleanData = { ...data };
  delete cleanData['page'];
  delete cleanData['sortBy'];
  delete cleanData['search'];

  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
  return post(`${CS_CHARGER_STATUS}${queryString}`, cleanData);
};

export const downloadChargerStatus = (data) => {
  if (data.search) {
    const search = data.search;
    delete data['search'];
    return downloadFile(`${CS_CHARGER_STATUS}?search=${search}`, data);
  }
  return downloadFile(`${CS_CHARGER_STATUS}`, data);
};

export const getChargerWidgets = (data) => {
  const status = data.status;
  return post(`${CHARGING_STATIONS}${WIDGETS}?widgits_by_plug=${status}`, data);
};

export const chargerStatus = {
  getChargerStatus,
  downloadChargerStatus,
  getChargerWidgets,
};
